import { Component } from '@angular/core';

@Component({
  selector: 'uni-card-header-illustration',
  templateUrl: './uni-card-header-illustration.component.html',
  styleUrls: ['./uni-card-header-illustration.component.scss'],
})
export class UniCardHeaderIllustrationComponent {
}
